<template>
  <div>
    <b-container fluid class="px-5">
      <div class="mt-4 d-flex flex-column flex-md-row align-items-start justify-content-md-between">
        <div class="mb-0">
          <h1 class="page-title">Espèces</h1>
          <h2 class="page-subtitle">Total : {{ totalCount }}</h2>
        </div>
        <b-button variant="primary" @click="clickOnCreateBtn" class="text-nowrap">
          <plus-icon size="18" class="mr-1" /> Ajouter une espèce
        </b-button>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TableSpecies"
          identifier="B122TableSpecies"
          init-b122-table-url="/species/initB122Table"
          get-b122-table-results-url="/species/getB122TableResults"
          :fields="tableFields"
          @setTotalCount="setTotalCount"
          @clickOnShowBtn="clickOnShowBtn"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
        >

        </b122-table>

      </b-card>
    </b-container>

    <!-- Modal Delete -->
    <species-delete-modal :selectedSpecies="ui.selectedSpecies" @didDeleteSpecies="didDeleteSpecies()"></species-delete-modal>

  </div>
</template>

<script>

import B122Table from "../../components/b122/B122Table";
import SpeciesDeleteModal from "../species/SpeciesDeleteModal";

export default {

  name: 'SpeciesIndex',

  components: {
    B122Table,
    SpeciesDeleteModal
  },

  data() {
    return {

      totalCount: 0,

      tableFields: [
        {
          label: "",
          key: "show",
          sortable: false
        },
        {
          label: "Nom",
          key: "name",
          sortable: true
        },
        {
          label: "Famille",
          key: "family.name",
          sortable: true
        },
        {
          label: "Nombre d'animaux",
          key: "animalsCount",
          sortKey: "size(d.animals)",
          sortable: true
        },
        {
          label: "Nombre d'aliments",
          key: "foodSpeciessCount",
          sortKey: "size(d.foodSpeciess)",
          sortable: true
        },
        {
          label: "",
          key: "actions"
        }
      ],

      ui: {
        selectedSpecies: null
      }
    }
  },

  methods: {

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'SpeciesCreate'
      })
    },

    clickOnShowBtn(row) {
      this.$router.push({
        name: 'SpeciesShow',
        params: {
          speciesId: row.item.id
        }
      })
    },

    clickOnEditBtn(row) {
      this.$router.push({
        name: 'SpeciesEdit',
        params: {
          speciesId: row.item.id
        }
      })
    },

    clickOnDeleteBtn(row) {
      this.ui.selectedSpecies = row.item
      this.$bvModal.show('species-delete-modal')
    },

    didDeleteSpecies() {
      this.ui.selectedSpecies = null;
      this.$refs.B122TableSpecies.refreshTable()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/species/SpeciesIndex.vue